import CustomModal from "../CustomModal";

const NotificationPreviewModal = ({
  isOpen,
  onRequestClose,
  messageHeader,
  message,
  selectedImage,
  handleRemoveImage,
  handleSendNotification,
  locationName, 
}) => {
  return (
    <CustomModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      className="add-admin-modal"
      contentLabel="Notification Preview"
    >
      <div className="view-info-inner">
        <div className="add-staff-head view-info-head">
          <h2>Notification Preview</h2>
        </div>
        <div className="preview-body">
          <div className="notification-preview-row">
            <span className="notification-preview-label header">Message Header:</span>
            <span className="notification-preview-value header">{messageHeader}</span>
          </div>
          <div className="notification-preview-row">
            <span className="notification-preview-label">Location:</span>
            <span className={`notification-preview-value location${locationName ? "" : " empty"}`}>
              {locationName || "No location selected"}
            </span>
          </div>
          <div className="notification-preview-row">
            <span className="notification-preview-label">Message:</span>
            <span className="notification-preview-value">{message}</span>
          </div>
          {selectedImage && (
            <div
              className="preview-image-container"
              style={{ position: "relative", display: "inline-block" }}
            >
              <img
                src={URL.createObjectURL(selectedImage)}
                alt="Preview"
                style={{ maxWidth: "100%", maxHeight: "300px" }}
              />
              <div
                className="remove-image"
                onClick={handleRemoveImage}
                style={{
                  position: "absolute",
                  top: "20px",
                  right: "-5px",
                  backgroundColor: "red",
                  borderRadius: "50%",
                  width: "20px",
                  height: "20px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  cursor: "pointer",
                  color: "white",
                  fontSize: "14px",
                }}
              >
                x
              </div>
            </div>
          )}
        </div>
        <div className="modal-button">
          <button onClick={onRequestClose}>Edit Message</button>
          <button
            style={{ backgroundColor: "#0473BD", color: "white" }}
            onClick={handleSendNotification}
          >
            Send Message
          </button>
        </div>
      </div>
    </CustomModal>
  );
};

export default NotificationPreviewModal;
